import { render, staticRenderFns } from "./NordMagazinePage.vue?vue&type=template&id=517156f5&"
import script from "./NordMagazinePage.vue?vue&type=script&lang=js&"
export * from "./NordMagazinePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Nord\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('517156f5')) {
      api.createRecord('517156f5', component.options)
    } else {
      api.reload('517156f5', component.options)
    }
    module.hot.accept("./NordMagazinePage.vue?vue&type=template&id=517156f5&", function () {
      api.rerender('517156f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/pages/NordMagazinePage.vue"
export default component.exports